const eventUserAvailabilityStatus = {
  OFFLINE: 0,
  ONLINE: 1,
  BUSY: 2,
}

export default eventUserAvailabilityStatus;